import config from './config.json';
import api from './endpoints.json';
import axios from 'axios';
import BasicAuth from './BasicAuth.js';
import BearerToken from './BearerToken.js';

let parseException = ( e ) => {
  let json = JSON.parse( e.response );
  const apiuri = config.global.root;

  if( e.status === 410 /* JWT Expired */) {
    return json;
  }

  if(json.status !== undefined && json.statusText !== undefined){
    return {
      status: parseInt(json.status, 10),
      statusText: json.statusText.replace('RequestError: ', '')
    };
  }

  let exception = {
    status: 400,
    statusText: 'Unhandled exception has occured!'
  }

  if( json.response !== undefined ) {
    if( json.response.data !== undefined ) {
      const data = json.response.data;
      if( data.error !== undefined ) {
        
        if( data.error.code !== undefined && data.error.message !== undefined ) {
          exception = {
            status: data.error.code,
            statusText: data.error.message
          };
        } 

      } else if( data.errno !== undefined ) {
        if( data.errno === 'EHOSTUNREACH' ) {
          exception = {
            status: 500,
            statusText: 'The server at ' + data.address + ' is unreachable connection failed.'
          };
        }
      } else if( data.status !== undefined && data.statusText !== undefined ) { 

        /* 
          [LH 2018-12-28] This logic was previously placed in the inccorect
          logic blocks had to add this back in the correct location so that  
          database exceptions would be handled correctly, and not thrown 
          back to bugsnag.
        */        

        // Set the  exception if it already has the status and statusText
        exception = {
          status: data.status,
          statusText: data.statusText
        };
      } else if ( data.reason !== undefined ) {
        // Transport Cost and other replies that do not have an error
        // in it's body
        exception = {
          status: data.code,
          statusText: data.message
        };
      }

    } else if( json.original !== undefined ) {
      exception = {
        status: exception.statusCode,
        statusText: 'API Rate Limits Exceeded (this is probably due to excessive refreshing behavior) "Stop rushing. Slow down and enjoy the beauty of life." - Debasish Mridha',
      };
    }
  } else {
    exception = {
      status: 500,
      statusText: apiuri + ' server is down.'
    };
  }

  exception.statusText = exception.statusText.replace( '[Microsoft][ODBC Driver 11 for SQL Server][SQL Server]','' );

  console.log(exception);
  return exception;
};

let buildQueryString = ( parameters ) => {
  let queryString = '';

  if( parameters !== undefined ) {

    if( parameters.length > 0 ){

      for ( var index = 0; index < parameters.length; index++ ) {
        if( parseInt( index, 10 ) === 0 ){
          queryString += '?';
        } else {
          queryString += '&';
        }
        let parameter = parameters[index];
        let keys = Object.keys( parameter );
        let key = keys[0];
        let value = parameter[key];
        queryString += ( key + '=' + escape( value.toString().trim() ) );
      }
    }
  }

  return queryString;
};

function EtelAPI( path ) {
  this.path = path;
  this.mode = config.global.mode;
  this.root = config.global.root;
  this.version = config.global.version;
  this.uri = '';
  this.list = '';
  this.ready = false;
  this.result = [];
  this.exception = undefined;

  try {

    var index = 0;
    var directories = this.path.split( '/' );

    var node = api[directories[index]];

    for( index = 1; index < directories.length; index++ ){
      node = node[directories[index]];
    }
    this.uri = node.uri;
    this.list = node.list;


  } catch( e ){

    this.exception = e;
  }

}

EtelAPI.prototype.getRoot = function(){
  return this.root;
};

EtelAPI.prototype.getEndPointUri = function(){
  return this.root + '/' + this.version + this.uri;
};

EtelAPI.prototype.getEndPointUriList = function(){
  return this.root + '/' + this.version + this.list;
};

EtelAPI.prototype.getAuthorization = function( body ){

  var config = {};

  try {

    var token = localStorage.getItem( 'id_token' );

    if( token === null ) {

      return config;

    } else {

      if( body !== undefined ) {
        config = {
          data: body,
          headers: {
            'Authorization': 'Bearer ' + token,
          }
        };
      } else {
        config = {
          headers: {
            'Authorization': 'Bearer ' + token,
          }
        };
      }
    }
  } catch( err ) {

    return config;
  }

  return config;
};

EtelAPI.prototype.get = function( parameters ) {
  let authorize = this.getAuthorization();
  let url = this.getEndPointUri();
  let queryString = buildQueryString( parameters );

  // URI cannot be blank, it must have a defined endpoint in
  // endpoints.json
  if( this.uri !== '' ){
    if( queryString !== '' ) {
      url += encodeURI( queryString );
    }

    return new Promise( function( resolve, reject ) {

      axios.get( url, authorize ).then( ( result ) => {

        const status_code = parseInt( result.status, 10 );
        if( status_code === 200 || status_code === 304 ){

          resolve( result.data );

        } else {

          reject( result );

        }

      } ).catch( ( e ) => {

        const response = parseException( e.request );

        reject( response );

      } );

    } );
  }
};

EtelAPI.prototype.getbyid = function( id, parameters ) {
  let authorize = this.getAuthorization();
  let url = this.getEndPointUri() + '/' + id.toString();
  let queryString = buildQueryString( parameters );

  if( queryString !== '' ) {
    url += encodeURI( queryString );
  }

  return new Promise( function( resolve, reject ) {

    axios.get( url, authorize ).then( ( result )=>{

      const status_code = parseInt( result.status, 10 );
      if( status_code === 200 || status_code === 304 ){

        resolve( result.data );

      } else {

        reject( result );
      }

    } ).catch( ( e ) => {

      const response = parseException( e.request ) ;

      reject( response );

    } );

  } );
};

EtelAPI.prototype.getlist = function( listtype ){
  let authorize = this.getAuthorization();
  let url = this.getEndPointUriList() + '/' + listtype;

  return new Promise( function( resolve, reject ) {

    axios.get( url, authorize ).then( ( result )=>{

      const status_code = parseInt( result.status, 10 );

      if( status_code === 200 || status_code === 304 ){

        resolve( result.data );

      } else {

        reject( result );
      }

    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );

  } );
};

EtelAPI.prototype.insert = function( body ){
  let url = this.getEndPointUri();
  let authorize = this.getAuthorization();

  return new Promise( function( resolve, reject ) {
    
    axios.post( url, body, authorize ).then( ( result ) =>{

      resolve( result );

    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );

  } );
};

EtelAPI.prototype.update = function( body ){
  let url = this.getEndPointUri();
  let authorize = this.getAuthorization();
  return new Promise( function( resolve, reject ) {
    axios.put( url, body, authorize ).then( ( result ) =>{

      //update should always return back one record array
      resolve( result );

    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );

  } );

};

EtelAPI.prototype.delete = function( id ) {
  let url = this.getEndPointUri();
  if( id ) {
    url = `${url}/${id.toString()}`;
  }
  let authorize = this.getAuthorization( );

  return new Promise( function( resolve, reject ) {

    axios.delete( url, authorize ).then( ( result ) =>{

      //delete should always return back one record array
      resolve( result );

    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );

  } );

};

EtelAPI.prototype.deletemany = function( parameters ){
  let authorize = this.getAuthorization( );
  let url = this.getEndPointUri();
  let queryString = buildQueryString( parameters );

  if( queryString !== '' ) {
    url += encodeURI( queryString );
  }

  return new Promise( function( resolve, reject ) {

    axios.delete( url, authorize ).then( ( result ) => {

      //delete should always return back one record array
      resolve( result );

    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );

  } );

};

EtelAPI.prototype.setpassword = function( body ) {
  const endpointuri = this.getEndPointUri();

  return new Promise( function( resolve, reject ) {

    axios.post( endpointuri + '/setpassword', body ).then( ( result ) => {

      const status_code = parseInt( result.status, 10 );
      if( status_code === 200 || status_code === 304 ){

        resolve( result );

      } else {

        reject( result );

      }

    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );

  } );
};

EtelAPI.prototype.passwordreset = function( body ) {
  const endpoint = this.getEndPointUri() + '/passwordreset';

  return new Promise( function( resolve, reject ) {

    axios.put( endpoint, body ).then( ( result ) => {

      const status_code = parseInt( result.status, 10 )
      if( status_code === 200 || status_code === 304 ){

        resolve( result );

      } else {

        reject( result );

      }
    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );
  } );

};

EtelAPI.prototype.sendFile = function( formdata ) {
  let url = this.getEndPointUri();
  let authorize = this.getAuthorization();

  return new Promise( function( resolve, reject ) {

    axios.post( url, formdata, authorize ).then( ( result ) =>{

      resolve( result );

    } ).catch( ( e ) => {

      let response = parseException( e.request );

      reject( response );

    } );

  } );
};

EtelAPI.prototype.login = function( username, password ) {
  const url = `${config.global.root}/${config.global.version}/${this.path}`;
  const options = {
    headers: {
      authorization: BasicAuth( username, password ).toString()
    }
  }
  return new Promise( ( resolve, reject ) => {
    axios.post( url, {}, options ).then( response => {
      resolve( response );
    }).catch( exception => {
      console.log(`EtelAPI.prototype.login() => ${JSON.stringify(exception)}`);
      reject( exception );
    });
  });
};

EtelAPI.prototype.verify = function( idToken ) {
  const url = `${config.global.root}/${config.global.version}/${this.path}`;
  const options = {
    headers: {
      Authorization: BearerToken(idToken).toString()
    }
  }
  return new Promise( ( resolve, reject ) => {
    axios.post( url, options ).then( response => {
      resolve( response );
    }).catch( exception => {
      reject( exception );
    });
  });
}

EtelAPI.prototype.logoff = function( idToken ) {
  const url = `${config.global.root}/${config.global.version}/${this.path}`;
  const options = {
    headers: {
      Authorization: BearerToken(idToken).toString()
    }
  }
  return new Promise( ( resolve, reject ) => {
    axios.delete( url, options ).then( response => {
      resolve( response );
    }).catch( exception => {
      reject( exception );
    });
  });
}

export default EtelAPI;



// WEBPACK FOOTER //
// ./src/api/EtelAPI.js